var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevronBoldDown(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.01 8.41"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#e1087e",
    d: "M7.01 8.41l7-7L12.6 0 7.01 5.59 1.41 0 0 1.41l7 7h.01z",
    "data-name": "Header - Opt 1 (Grey)"
  })));
}
export default SvgChevronBoldDown;